export const menu = [
    { titulo: 'Inicio', link: '/' },
    { titulo: 'Quienes Somos', link: '/Actividades' },
    { titulo: 'Nuestro Equipo', link: '' },
    { titulo: 'Galería', link: '/Galeria' },
    { titulo: 'Contacto', link: '/Contacto' }
]